import { useRoutes } from 'react-router-dom';
import { AuthGuard } from '../auth';
import Home from '../pages/Home';
import Cart from '../pages/Cart';
import Membership from '../pages/Membership';
import SignIn from '../pages/SignIn';
import Register from '../pages/Register';
import ForgotPassword from '../pages/ForgotPassword';
import VerifyOtp from '../pages/VerifyOtp';
import RecoverPassword from '../pages/RecoverPassword';
import OurPickDetails from '../pages/OurPickDetails';
import ProductDetails from '../pages/ProductDetails';
import Checkout from '../pages/Checkout';
import CheckoutResult from '../pages/CheckoutResult';
import Categories from '../pages/Categories';
import BrandDetails from '../pages/BrandDetails';
import NewProducts from '../pages/NewProducts';
import Brands from '../pages/Brands';
import Wishlist from '../pages/Wishlist';
import SaleProducts from '../pages/SaleProducts';
import Profile from '../pages/Profile';
import MyCoupons from '../pages/MyCoupons';
import MyOrders from '../pages/MyOrders';
import PointOffers from '../pages/PointOffers';
import BlogPost from '../pages/BlogPost';
import Collection from '../pages/Collection';
import Search from '../pages/Search';
import Apps from '../pages/Apps';

const AppRouter = () => {
  const routes = useRoutes([
    {
      path: '/',
      element: <Home />
    },
    {
      path: '/search',
      element: <Search />
    },
    {
      path: '/cart',
      element: (
        <Cart />
      )
    },
    {
      path: '/membership',
      element: (
        <AuthGuard>
          <Membership />
        </AuthGuard>
      )
    },
    {
      path: '/profile',
      element: (
        <AuthGuard>
          <Profile />
        </AuthGuard>
      )
    },
    {
      path: '/sign-in',
      element: <SignIn />
    },
    {
      path: '/register',
      element: <Register />
    },
    {
      path: '/forgot-password',
      element: <ForgotPassword />
    },
    {
      path: '/verify-otp',
      element: <VerifyOtp />
    },
    {
      path: '/recover-password',
      element: <RecoverPassword />
    },
    {
      path: '/our-picks',
      element: <OurPickDetails />
    },
    {
      path: '/categories/:categoryId/:categoryName',
      element: <Categories />
    },
    {
      path: '/brand/:brandId/:brandName',
      element: <BrandDetails />
    },
    {
      path: '/new-products',
      element: <NewProducts />
    },
    {
      path: '/sale-products',
      element: <SaleProducts />
    },
    {
      path: '/brands',
      element: <Brands />
    },
    {
      path: '/wishlist',
      element: <Wishlist />
    },
    {
      path: '/my-coupons',
      element: (
        <AuthGuard>
          <MyCoupons />
        </AuthGuard>
      )
    },
    {
      path: '/point-offers',
      element: (
        <AuthGuard>
          <PointOffers />
        </AuthGuard>
      )
    },
    {
      path: '/my-orders',
      element: (
        <AuthGuard>
          <MyOrders />
        </AuthGuard>
      )
    },
    {
      path: '/product/:productId',
      element: <ProductDetails />
    },
    {
      path: '/checkout',
      element: <Checkout />
    },
    {
      path: '/checkout-result',
      element: <CheckoutResult status="success" />
    },
    {
      path: '/page/:slug',
      element: <BlogPost />
    },
    {
      path: '/collection/:urlPath',
      element: <Collection />
    },
    {
      path: '/apps',
      element: <Apps />
    }
  ]);

  return routes;
};

export default AppRouter; 
